// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__fk0tK","childInformation":"table_childInformation__OsbGv","description":"table_description__2Sq6Y","privacy":"table_privacy__2nY23"};